/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type SaveNormalMessageChatReplyPlannerSettingInput = {
  isEnabled: boolean;
  message: string;
};

export type SaveNormalMessageChatReplyPlannerSettingMutationVariables = Exact<{
  input: Types.SaveNormalMessageChatReplyPlannerSettingInput;
}>;


export type SaveNormalMessageChatReplyPlannerSettingMutation = { saveNormalMessageChatReplyPlannerSetting: { success: boolean } };


export const SaveNormalMessageChatReplyPlannerSettingDocument = gql`
    mutation saveNormalMessageChatReplyPlannerSetting($input: SaveNormalMessageChatReplyPlannerSettingInput!) {
  saveNormalMessageChatReplyPlannerSetting(input: $input) {
    success
  }
}
    `;

/**
 * __useSaveNormalMessageChatReplyPlannerSettingMutation__
 *
 * To run a mutation, you first call `useSaveNormalMessageChatReplyPlannerSettingMutation` within a Vue component and pass it any options that fit your needs.
 * When your component renders, `useSaveNormalMessageChatReplyPlannerSettingMutation` returns an object that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - Several other properties: https://v4.apollo.vuejs.org/api/use-mutation.html#return
 *
 * @param options that will be passed into the mutation, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/mutation.html#options;
 *
 * @example
 * const { mutate, loading, error, onDone } = useSaveNormalMessageChatReplyPlannerSettingMutation({
 *   variables: {
 *     input: // value for 'input'
 *   },
 * });
 */
export function useSaveNormalMessageChatReplyPlannerSettingMutation(options: VueApolloComposable.UseMutationOptions<SaveNormalMessageChatReplyPlannerSettingMutation, SaveNormalMessageChatReplyPlannerSettingMutationVariables> | ReactiveFunction<VueApolloComposable.UseMutationOptions<SaveNormalMessageChatReplyPlannerSettingMutation, SaveNormalMessageChatReplyPlannerSettingMutationVariables>> = {}) {
  return VueApolloComposable.useMutation<SaveNormalMessageChatReplyPlannerSettingMutation, SaveNormalMessageChatReplyPlannerSettingMutationVariables>(SaveNormalMessageChatReplyPlannerSettingDocument, options);
}
export type SaveNormalMessageChatReplyPlannerSettingMutationCompositionFunctionResult = VueApolloComposable.UseMutationReturn<SaveNormalMessageChatReplyPlannerSettingMutation, SaveNormalMessageChatReplyPlannerSettingMutationVariables>;